<template>
    <CicPopup :saveable="editing" title="New WhatsApp Account" @blur="$emit('blur')" @input="saveItem">
        <ul class="item-form">
            <li class="form-label-first">
                {{ $t('Account Name') }}
            </li>
            <li>
                <CicTextbox
                    id="accountName"
                    :enabled="editing"
                    :value="item.accountName"
                    :class="{ highlight: !validation.accountName }"
                    :maxlength="64"
                    @input="(val) => updateFieldValue('accountName', val)"
                />
            </li>
            <li class="form-label">{{ $t('Timeout Message') }}</li>
            <li>
                <CicTextarea
                    id="timeoutMessage"
                    :enabled="editing"
                    :value="item.timeoutMessage"
                    :class="{ highlight: !validation.timeoutMessage }"
                    :autosize="true"
                    :maxlength="2000"
                    @input="(val) => updateFieldValue('timeoutMessage', val)"
                />
            </li>
            <li class="form-label">{{ $t('Channel ID') }}</li>
            <li>
                <cic-textbox id="channelId" :value="item.channelId" :enabled="false" />
            </li>
            <li class="form-label">{{ $t('Phone Number') }}</li>
            <li>
                <cic-textbox id="phoneNumber" :value="item.phoneNumber" :enabled="false" />
            </li>
        </ul>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup.vue';
    import CicTextbox from '@/components/inputs/CicTextbox.vue';
    import CicTextarea from '@/components/inputs/CicTextarea.vue';

    export default {
        name: 'EditWhatsAppAccount',
        components: {
            CicPopup,
            CicTextbox,
            CicTextarea,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                editing: false,
                validation: {
                    accountName: true,
                    timeoutMessage: true,
                },
            };
        },
        created() {
            this.editing = !this.item.accountId || this.$store.hasRight('EDIT_ACCESS_TYPE_24');
        },
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
            saveItem() {
                this.validation.accountName = true;

                if (this.item.accountName.trim() === '') {
                    this.validation.accountName = false;
                    alert(this.$t('Account Name is a required field'));
                    return;
                }

                this.validation.timeoutMessage = true;

                if (this.item.timeoutMessage.trim() === '') {
                    this.validation.timeoutMessage = false;
                    alert(this.$t('Timeout Message is a required field'));
                    return;
                }

                this.$emit('input');
            },
        },
    };
</script>
